import { runningEnv } from '@frontend/doraemon';

// 通过ua判断是否在App内,如果在App内部则返回相应的 神策ProductName
let appProductNameCache:string | undefined;
export function getAppProductName() {
  if (appProductNameCache) {
    return appProductNameCache;
  }
  let result:string | undefined;
  // 小火箭APP
  if (runningEnv.isRocketAppGetter()) {
    result = '小火箭幼儿编程App';
  }
  // 探月APP
  else if (runningEnv.isLunarAppGetter()) {
    result = '探月少儿编程App';
  }
  // 编程猫App
  else if (runningEnv.isGrowAppGetter()) {
    result = '编程猫App';
  }
  appProductNameCache = result;
  return result;

}
